
    import { ORSchedule, Event } from "@/models";
    import moment from "moment";
    import { Component, Vue, Prop } from "vue-property-decorator";
    import { namespace } from "vuex-class";
    import ErrorNotification from "./ErrorNotification.vue";
    import ConfirmMsgPopUp from "@/views/shared/ConfirmMsgPopUp.vue";
    const profile = namespace("profile");
    const schedule = namespace("schedule");
    import { ModelListSelect } from 'vue-search-select'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { useAppInsights } from '../../store/modules/AppInsights'
    
    @Component({
        components: {
            ErrorNotification,
            ModelListSelect,
            Loading,
            ConfirmMsgPopUp
        },
    })
    export default class Request extends Vue {
        @schedule.State
        public requestDetail!: any;

        @Prop() calSelectedDates!: any;
        @Prop() currentEvent!: any;
        @Prop() additionalRequestEvent!: any;
        @Prop() dayChanged!: any;
        public data!: any;
        availiableDates: string[] = [];
        buttonCaption: string = "";
        isLoading: boolean = false;
        errorMsg: string = "";
        errorType: string = "error";
        showErrorMsg: boolean = false;
        disableduration: boolean = false;
        maxTimeDuration: any = 12;
        isFullScreenLoading: boolean = false;
        loaderColor: string = "#0085ca";
        isConfirmModalVisible: boolean = false;
        confirmMsgValue: string = '';
        maxCommentsCharacters: number = 25;

        @profile.State public profileData!: any;
        currentSchedule!: ORSchedule;
        @profile.State
        isAdmin!: boolean;

        @schedule.State
        public userSchedules!: any;

        @profile.State
        isImpersonating!: boolean;
        
        @profile.State
        appInsightEventData!: any;

        constructor() {
            super();
            this.data = {
                selectedDate: [],
                startTime: "",
                defaultStartTime: "",
                duration: "",
                defaultDuration: "",
                shift: "",
                defaultShift: "",
                minutes: "",
                hours: 0,
                startDateTime: "",
                durationList: [],
                availableShifts: [],
                comment: "",
                defaultComment: "",
            };
        }

        async mounted(): Promise<void> {
            await this.loadData();
        }

        async loadData() {
            try {
                this.generateTimeList(this.maxTimeDuration);
                this.buttonCaption =
                    this.currentEvent.type == "Request" ? "Withdraw" : "Add to Schedule";
                await this.getSelectedDates();
                if (this.currentEvent.type == "Request") {
                    this.getRequestEvent();
                    this.disableduration = false;
                }
                this.data.defaultStartTime = "";
                this.data.defaultDuration = "";
                this.data.defaultShift = "";
                this.data.availableShifts = [];
                this.data.defaultComment = "";

                for (var i = 0; i < this.profileData.departmentShifts.length; i++)
                {
                    let selectedDate = moment(new Date(this.calSelectedDates.startDate.getTime() ));
                   
                    if ((this.profileData.departmentShifts[i].effective === null)
                        && (this.profileData.departmentShifts[i].expires === null))
                    {
                        this.data.availableShifts.push(this.profileData.departmentShifts[i]);
                    }
                    else if ((this.profileData.departmentShifts[i].effective !== null)
                            && (this.profileData.departmentShifts[i].expires !== null)) 
                    {
                        if((moment(this.profileData.departmentShifts[i].effective) <= selectedDate) && (moment(this.profileData.departmentShifts[i].expires) >= selectedDate))
                        {
                            this.data.availableShifts.push(this.profileData.departmentShifts[i]);
                        }
                    }
                    else if (((this.profileData.departmentShifts[i].effective === null)) && (selectedDate <=  moment(this.profileData.departmentShifts[i].expires)))
                    {
                        this.data.availableShifts.push(this.profileData.departmentShifts[i]);
                    } 
                    else if(((this.profileData.departmentShifts[i].expires === null)) && (selectedDate >= moment(this.profileData.departmentShifts[i].effective)))
                    {
                        this.data.availableShifts.push(this.profileData.departmentShifts[i]);                        
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

        generateTimeList(maxDuration: any): void {
            const hours: any = [];
            for (let hour = 0; hour < maxDuration; hour++) {
                hours.push({
                    label: `${hour + 1} hour`,
                    value: hour + 1,
                });
            }
            this.data.durationList = hours;
        }

        widthdrawMode(additionalRequestEvent): boolean {
            return Boolean(this.currentEvent.type == "Request" && additionalRequestEvent == false);
        }

        async getSelectedDates(): Promise<void> {
            var startSD = moment(this.calSelectedDates.startDate, "M/D/YYYY");
            var endSD = moment(this.calSelectedDates.endDate, "M/D/YYYY");
            var diffDays = endSD.diff(startSD, "days");
            let currentDate: Date = new Date(this.calSelectedDates.startDate);
            this.availiableDates = [];
            for (var i = 0; i < diffDays; i++) {
                const date = moment(currentDate)
                    .format("dddd, MMMM DD YYYY")
                    .toString();
                this.availiableDates.push(date);
                currentDate.setDate(currentDate.getDate() + 1);
            }
            this.data.selectedDate = JSON.parse(JSON.stringify(this.availiableDates));
        }

        getRequestEvent() {
            var payload = { 
                username: this.profileData.username, 
                id: this.currentEvent.id
            };  

            this.$store
                .dispatch("schedule/GetRequestDetails", payload)
                .then((res: any) => {
                    if (this.requestDetail != undefined) {
                        this.data.shift = this.requestDetail.departmentShiftId;
                        var requestEventStartDateTime = new Date(
                            this.requestDetail.startTime
                        );
                        var requeststartTime = moment(requestEventStartDateTime).format(
                            "HH:mm"
                        );
                        var requestHours = this.requestDetail.hours;
                        this.data.duration = requestHours;
                        this.data.startTime = requeststartTime;
                        this.data.comment = this.requestDetail.comment;
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
        }

        async FireAction(additionalRequestEvent) {
            if (!this.widthdrawMode(additionalRequestEvent)) {
                //If there is no email address present in profile then doesn't allow them to send Non-productive shift request
                var selectedShift =  this.data.availableShifts.find(x=> x.id == this.data.shift);           
                if(this.profileData.email == null || 
                    this.profileData.email == undefined || this.profileData.email == "")
                {
                    this.showErrorMsg = true;
                    this.errorMsg = "Request Failed: There is no email address associated with your profile. To update this information, contact your manager, FSA, or call HCA HR Answers at 1-844-HR-ANSWR(472-6797)."
                    return;
                }
                this.isLoading = true;
                let clickEventNextDate: Date = new Date(this.calSelectedDates.startDate);
                if(this.calSelectedDates.endDate==null)
                {
                    this.calSelectedDates.endDate = clickEventNextDate;
                } 
                else
                {
                    this.calSelectedDates.endDate = new Date(this.calSelectedDates.endDate);
                } 
                let requestBody = {
                    tenantId: this.profileData.tenantId,
                    startDate: new Date(
                        this.calSelectedDates.startDate.getTime() -
                        this.calSelectedDates.startDate.getTimezoneOffset() * 60000
                    ).toISOString(),
                    endDate: new Date(
                        this.calSelectedDates.endDate.getTime() -
                        this.calSelectedDates.endDate.getTimezoneOffset() * 60000
                    ).toISOString(),
                    comment: additionalRequestEvent ? this.data.defaultComment : this.data.comment,
                    email: this.profileData.email,
                    shifts: [] as any[],
                };
                for (var i = 0; i < this.data.selectedDate.length; i++) {
                    var eventStartDateTime = new Date(this.data.selectedDate[i]);
                    if (!additionalRequestEvent) {
                        eventStartDateTime.setHours(
                            Number(this.data.startTime.split(":")[0]),
                            Number(this.data.startTime.split(":")[1])
                        );
                    }
                    else {
                        eventStartDateTime.setHours(
                            Number(this.data.defaultStartTime.split(":")[0]),
                            Number(this.data.defaultStartTime.split(":")[1])
                        );
                    }
                    eventStartDateTime.setFullYear(
                        this.calSelectedDates.startDate.getFullYear()
                    );
                    let objReq = {
                        departmentShiftId: additionalRequestEvent ? this.data.defaultShift : this.data.shift,
                        startDateTime: new Date(
                            eventStartDateTime.getTime() -
                            eventStartDateTime.getTimezoneOffset() * 60000
                        ).toISOString(), // Add Time
                        hours: Number(additionalRequestEvent ? this.data.defaultDuration : this.data.duration), // Add Hours
                        minutes: 0,
                    };

                    requestBody.shifts.push(objReq);
                }
                this.isFullScreenLoading = true;
                this.$store
                    .dispatch("schedule/RequestSchedule", requestBody)
                    .then(() => {
                        // showing message in MyScheduleView Screen and close modal only on success
                        this.isFullScreenLoading = false;
                        this.$emit(
                            "showSuccessMsgPopUp",
                            true,
                            "Time off request successfully submitted."
                        );
                        this.$emit("closeSharedModal");
                    })
                    .finally(() => { this.isLoading = false; this.isFullScreenLoading = false; })
                    .catch((err: any) => {
                        this.isFullScreenLoading = false;
                        if (err) {
                            let parseResponse =
                                err.request.response != ""
                                    ? err.request.response
                                    : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";

                            this.showErrorMsg = true;
                            this.errorMsg = parseResponse;
                        }
                    });
            }
            else //
            {
                if (this.profileData.selfScheduleToCommitment == true) {
                    if (this.isBelowCommitment()) {
                        this.confirmMsgValue = "By withdrawing this request, you will be under your shift commitment. Do you want to proceed?";
                        this.isConfirmModalVisible = true;
                    }
                    else {
                        this.confirmMsgValue = "This shift request will be removed. Do you want to proceed?";
                        this.isConfirmModalVisible = true;
                    }
                }
                else {
                    this.confirmMsgValue = "This shift request will be removed. Do you want to proceed?";
                    this.isConfirmModalVisible = true;
                }
            }
        }

        selectDates(date: string): void {
            const selectedDates: any = this.data.selectedDate;
            const index = selectedDates.indexOf(date);
            if (index > -1) {
                selectedDates.splice(index, 1);
            } else {
                selectedDates.push(date);
            }
        }

        shiftChange(additionalRequestEvent): void {                     
            let defaultDuration = this.profileData.partOfDayDuration;
            let defaultStartTime = this.formatTime(this.profileData.partOfDayStartTime).toString();
            
            this.generateTimeList(this.maxTimeDuration);
            this.data.duration = defaultDuration;
            this.data.defaultDuration = defaultDuration;
            this.data.startTime = defaultStartTime;
            this.data.defaultStartTime = defaultStartTime;
            this.disableduration = true;            

            if (this.showErrorMsg) {
                this.showErrorMsg = false;
                this.errorMsg = "";
            }
        }

        formatTime(t: Date): string {
            return moment(t).format("HH:mm:ss");
        }

        getDisableDuration(additionalRequestEvent) {
            var isDisabled = false;
            if (this.currentEvent.type == "Request" && !additionalRequestEvent) {
                isDisabled = false;
            }
            else if (this.currentEvent.type == "Request" && additionalRequestEvent) {
                isDisabled = this.disableduration;
            }
            else if (this.currentEvent.type != "Request") {
                isDisabled = this.disableduration;
            }
            return !isDisabled;
        }
        disableSubmit(additionalRequestEvent) {
            var returnValue = true;
            if (this.isLoading) {
                returnValue = true;
            }
            else if (this.currentEvent.type == "Request" && !additionalRequestEvent) {
                returnValue = false;
            }
            else if (this.currentEvent.type == "Request" && additionalRequestEvent) {
                returnValue = Boolean(
                    this.data.defaultShift &&
                    this.data.defaultStartTime &&
                    this.data.defaultDuration &&
                    this.data.selectedDate.length > 0
                ) != true;
            }
            else {
                returnValue = Boolean(
                    this.data.shift &&
                    this.data.startTime &&
                    this.data.duration &&
                    this.data.selectedDate.length > 0
                ) != true;
            }
            return returnValue;
        }

        async confirmedClicked() {
            this.isLoading = true;
            this.isConfirmModalVisible = false;
            this.isFullScreenLoading = true;
            await this.$store
                .dispatch("schedule/WithdrawRequestEvent", this.requestDetail.requestId)
                .then(() => {
                    this.isFullScreenLoading = false;
                    this.$emit("showSuccessMsgPopUp");
                    this.$emit("closeSharedModal");
                })
                .finally(() => { this.isLoading = false; this.isFullScreenLoading = false; })
                .catch((err: any) => {
                    this.isFullScreenLoading = false;
                    this.$emit("showSuccessMsgPopUp", false);
                    if (err) {
                        let parseResponse =
                            err.request.response != ""
                                ? err.request.response
                                : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                        this.showErrorMsg = true;
                        this.errorMsg = parseResponse;
                    }
                });

        }

        isBelowCommitment() {
            let currdate = this.currentEvent.date;
            let currsched = this.userSchedules.length? this.userSchedules[0]: null;
            currsched = null;

            this.userSchedules.forEach((sched: any) => {
                let startDt, endDt, currDt;
                startDt = sched.startDate;
                currDt = currdate;
                endDt = sched.endDate;
                if (
                    new Date(startDt) <= new Date(currDt) &&
                    new Date(endDt) >= new Date(currDt)
                ) {
                    currsched = sched;
                    return;
                }
            });

            let totalHrs = 0,
                totalMins = 0,
                weekStartDate: Date = new Date(currsched.startDate),
                weekEndDate: Date = new Date(currsched.startDate),
                weekEvents!: Event[],
                weekHours: number,
                isOverallCommitmentBelow: boolean = false,
                isWeekendCommitmentBelow: boolean = false;

            for (var i = 0; i < this.profileData.weeksInSchedule; i++) {
                if (i == 0) {
                    weekEndDate.setDate(weekStartDate.getDate() + 6);
                }
                else {
                    weekStartDate.setDate(weekStartDate.getDate() + 7);
                    weekEndDate.setDate(weekStartDate.getDate() + 6);
                }

                if (weekStartDate <= new Date(currdate) && new Date(currdate) <= weekEndDate) {
                    weekEvents = currsched.events.filter(
                        (event: Event) =>
                            new Date(event.date) >= weekStartDate &&
                            new Date(event.date) <= weekEndDate && event.isCommitment == true &&
                            (event.type == "Pending" || event.type == "Assignment" || event.type == "Request")
                    );

                    weekEvents.forEach((event: Event) => {
                        totalHrs += event.hours;
                        totalMins += event.minutes;
                    });
                    if(this.currentEvent.isCommitment)
                    {
                        weekHours = Math.round((totalHrs + (totalMins / 60)) - (this.currentEvent.hours + (this.currentEvent.minutes / 60)));
                    }
                    else
                    {
                      weekHours = Math.round((totalHrs + (totalMins / 60)));
                    }
                    if (this.currentEvent.isWeekend) {
                        let weekendScheduledEvents: Event[] = currsched.events.filter(
                            (event: Event) =>
                                new Date(event.date) >= new Date(currsched.startDate) &&
                                new Date(event.date) <= new Date(currsched.endDate) &&
                                (event.type == "Pending" || event.type == "Assignment" || event.type == "Request") &&
                                event.isWeekend
                        );

                        if (this.profileData.displayWSC) {
                            if ((weekendScheduledEvents.length - 1) >= this.profileData.reqCountWSC) {
                                isWeekendCommitmentBelow = false;
                            }
                            else {
                                isWeekendCommitmentBelow = true;
                            }
                        }
                        else {
                            isWeekendCommitmentBelow = false;
                        }
                    }
                    if (weekHours < this.profileData.guarenteedHours || isWeekendCommitmentBelow) {
                        isOverallCommitmentBelow = true;
                    }
                    break;
                }
            }
            return isOverallCommitmentBelow;
        }
    }
